interface Address {
  street?: string;
  zip?: string;
  city?: string;
}

/**
 * Generates a Google Maps URL from address components
 * @param address - Object containing address components (street, zip, city)
 * @returns Google Maps URL string
 */
export const getGoogleMapsUrl = (address: Address): string => {
  const { street = '', zip = '', city = '' } = address;

  // Clean and format address components
  const cleanStreet = street.trim();
  const cleanZip = zip.trim();
  const cleanCity = city.trim();

  // Build the address string
  const addressString = [cleanStreet, cleanZip, cleanCity].filter(Boolean).join(', ');

  // Encode the address for URL
  const encodedAddress = encodeURIComponent(addressString);

  return `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
};
